import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Crown } from "lucide-react";
import apiClient from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import logo from "@/assets/logo.png";

export default function MembershipSuccess() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("failed"); return; }

    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await apiClient.get(`/memberships/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refreshUser();
          setStatus("success");
          return;
        }
      } catch (e) { /* ignore */ }
      if (attempts < 6) setTimeout(poll, 2000);
      else setStatus("failed");
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid-overlay flex items-center justify-center px-5">
      <div className="w-full max-w-md glass rounded-3xl p-10 text-center animate-in-up">
        <img src={logo} alt="logo" className="h-12 w-auto object-contain mx-auto mb-8" />
        {status === "checking" && (
          <>
            <Loader2 className="w-16 h-16 mx-auto mb-6 animate-spin" style={{ color: "#8b5cf6" }} />
            <h1 className="font-display text-2xl font-bold text-white mb-2">Activating Membership</h1>
            <p className="text-slate-400">Processing your subscription...</p>
          </>
        )}
        {status === "success" && (
          <>
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl flex items-center justify-center" style={{ background: "rgba(139,92,246,0.18)", border: "1px solid rgba(139,92,246,0.5)" }}>
              <Crown className="w-9 h-9" style={{ color: "#c4b5fd" }} />
            </div>
            <h1 className="font-display text-2xl font-bold text-white mb-2">Membership Activated!</h1>
            <p className="text-slate-400 mb-8">Your perks are now live. Enjoy discounts, bonus points & VIP access.</p>
            <button onClick={() => navigate("/dashboard")} className="neon-btn w-full py-4" data-testid="go-dashboard">
              <CheckCircle2 className="w-5 h-5" /> Go to Dashboard
            </button>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle className="w-16 h-16 mx-auto mb-6" style={{ color: "#ff2e97" }} />
            <h1 className="font-display text-2xl font-bold text-white mb-2">Activation Pending</h1>
            <p className="text-slate-400 mb-8">We couldn't confirm your payment yet. It may take a moment to reflect.</p>
            <button onClick={() => navigate("/membership")} className="neon-outline-btn w-full py-4">Back to Memberships</button>
          </>
        )}
      </div>
    </div>
  );
}
